const isLocalStorageEnabled = () => {
  try {
    return !!(typeof window === 'object' && window === window.parent && window.localStorage)
  } catch (e) {
    // Can't get the above code to throw an exception with jest, but does throw an exception in chrome with localStorage disabled
    /* istanbul ignore next */
    return false
  }
}

export default isLocalStorageEnabled
